module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.14.0.0.box.424.450.829.102.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-indent": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.14.0.0.box.424.450.829.102.q.90"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.1.0.box.197.821.1286.589.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.0.box.197.821.1286.372.q.60"
    }
  }, [_vm._v("My book is a story about New Orleanians an"), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.1.0"
    }
  }), _vm._v("d Louisianians . . . and people everywhere. A ghost writer almost certainly would write more eloquently than I, but I feared that some of the passion that my wife, Mary, and I feel for the people of our city and our state inevitably would be lost. So, I decided that every single word, thought, and experience herein would originate with this passionate New Orleanian and Louisianian.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.1.box.197.1201.1285.209.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.2.0"
    }
  }), _vm._v("This book would not have been written without the assistance and constant encouragem"), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.2.0.0"
    }
  }), _vm._v("ent of my distinguished nephew, Julian L. McPhillips, Jr., a pr"), _c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _vm._v("ominent Montgomery, Alabama, attorney. I do not have a better friend, anywhere.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58621dec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0009.vue
// module id = 60
// module chunks = 0